<template>
  <div id="seleccion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <v-card flat v-if="tabSelected == 'Digitacion'">
                <digitacion-sub-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></digitacion-sub-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Captura'">
                <captura-sub-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></captura-sub-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Evolucion Grafica'">
                <evolucion-grafica-sub-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></evolucion-grafica-sub-tab>
              </v-card>

              <v-card flat v-if="tabSelected == 'Documentos'">
                <documento-sub-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></documento-sub-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DigitacionSubTab from "@/modules/captura/views/seguimiento/digitacion/DigitacionSubTab.vue";
import CapturaSubTab from "@/modules/captura/views/seguimiento/captura/CapturaSubTab.vue";
import EvolucionGraficaSubTab from "@/modules/captura/views/seguimiento/evolucionGrafica/EvolucionGraficaSubTab.vue";
import DocumentoSubTab from "@/modules/captura/views/seguimiento/evolucionGrafica/DocumentoSubTab.vue";

export default {
  name: "seguimiento-sub-tab",

  components: {
    DigitacionSubTab,
    CapturaSubTab,
    EvolucionGraficaSubTab,
    DocumentoSubTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Captura", "Evolucion Grafica", "Documentos"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },

    selected(tab) {
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
